module.exports = "/images/dashboard-active.svg?139ed58993f64b29246422a275c9bfa7";